import * as ReactModal from 'react-modal';
import classNames from 'classnames';

// styles
import CloseIcon from '@svg/close.svg';

import s from './NModal.sss';

export type ModalProps = ReactModal.Props & {
  // Mobile full screen size
  mFullScreen?: boolean
  // Tablet full screen size
  tFullScreen?: boolean
  withClose?: boolean;
  animate?: boolean;
  containerClassName?: string;
};

export const Modal: React.FC<React.PropsWithChildren<ModalProps>> = ({
  children,
  className,
  containerClassName,
  overlayClassName,
  isOpen,
  onRequestClose,
  withClose,
  mFullScreen = false,
  tFullScreen = false,
  animate = true,
  ...props
}) => {
  const app = document?.getElementById('app');

  return (
    <ReactModal
      ariaHideApp={!!app}
      appElement={app || undefined}
      closeTimeoutMS={200}
      contentLabel="Modal"
      isOpen={isOpen}
      bodyOpenClassName={s.noScroll}
      className={{
        base: classNames(
          s.container,
          containerClassName,
          {
            [s.containerAnimate]: animate,
            [s.mobileFullScreen]: mFullScreen,
            [s.tabletFullScreen]: tFullScreen,
          },
        ),
        afterOpen: animate ? s.afterOpen : '',
        beforeClose: animate ? s.beforeClose : '',
      }}
      overlayClassName={{
        base: classNames(s.overlay, {
          [s.overlayAnimate]: animate,
          [s.mobileFullScreen]: mFullScreen,
          [s.tabletFullScreen]: tFullScreen,
        }, overlayClassName),
        afterOpen: animate ? s.afterOpen : '',
        beforeClose: animate ? s.beforeClose : '',
      }}
      onRequestClose={onRequestClose}
      {...props}
    >
      <div
        className={classNames(s.root, className, {
          [s.mobileFullScreen]: mFullScreen,
          [s.tabletFullScreen]: tFullScreen,
        })}
        >
        <>
          {children}
          {withClose
          && (
            <div onClick={onRequestClose} className={s.close}>
              <CloseIcon
                className={s.icon}
                width='24'
                height='24'
              />
            </div>
          )}
        </>
      </div>
    </ReactModal>
  );
};

export default Modal;
